import { Col, Form, Row } from "antd";
import { InputCalendarioDate } from "components/input/InputCalendarioDate";
import { SelectProdutorMultiple } from "components/select/SelectProdutorMultiple";
import { FormItemNoMargin } from "pages/relatorios/components/FormItemNoMargin";
import { useRelatorioStore } from "pages/relatorios/store";
import type { ApiRelatorioParams } from "pages/relatorios/types/ApiRelatorioParams";
import { useMemo } from "react";
import { SelectRotaMultiple } from "./SelectRotaMultiple";

export function FilterBarAnaliseQualidade() {
	const filter = useRelatorioStore((s) => s.filter);
	const applyFilter = useRelatorioStore((s) => s.applyFilter);
	const [formFiltroAvancado] = Form.useForm<ApiRelatorioParams>();
	const rotaIds = useMemo(() => filter?.filterRotas?.map((rota) => rota.rot_idpk) ?? [], [filter?.filterRotas]);
	const produtorIds = useMemo(() => filter?.filterProdutores?.map((produtor) => produtor.for_idpk) ?? [], [filter?.filterProdutores]);

	const handleFilter = (formValues: ApiRelatorioParams): void => {
		applyFilter({
			...formValues,
			filterData: undefined,
		});
	};

	return (
		<Form layout="vertical" form={formFiltroAvancado} onFinish={handleFilter}>
			<Row gutter={[10, 10]}>
				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin label="Produtor">
						<SelectProdutorMultiple
							value={produtorIds}
							selectedProdutores={filter?.filterProdutores ?? []}
							placeholder="Todos os produtores"
							selectAllLabel="Todos os produtores"
							onChange={(_, produtores) => {
								useRelatorioStore.setState((state) => ({
									filter: {
										...state.filter,
										filterProdutores: produtores,
										filterData: undefined,
									},
								}));
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin name="filterMesRef" label="Mês Ref">
						<InputCalendarioDate
							picker="month"
							format="MM/YYYY"
							placeholder="Mês Ref."
							onChange={(value) => {
								useRelatorioStore.setState({
									filter: {
										...filter,
										filterMesRef: value,
										filterData: undefined,
									},
								});
							}}
						/>
					</FormItemNoMargin>
				</Col>

				<Col xs={24} sm={12} md={8} lg={8} xl={6} xxl={6}>
					<FormItemNoMargin label="Rota">
						<SelectRotaMultiple
							value={rotaIds}
							selectedRotas={filter?.filterRotas ?? []}
							placeholder="Todas as rotas"
							selectAllLabel="Todas as rotas"
							onChange={(_, rotas) => {
								useRelatorioStore.setState((state) => ({
									filter: {
										...state.filter,
										filterRotas: rotas,
										filterData: undefined,
									},
								}));
							}}
						/>
					</FormItemNoMargin>
				</Col>
			</Row>
		</Form>
	);
}
